<template>
    <el-dialog
        class="event-select-popup"
        :visible.sync="showDialog"
        :show-close="showCloseModal"
        :close-on-press-escape="showCloseModal"
        :title="titleMessageText"
    >
        <el-row
            v-if="currentMode === componentModes.SELECT_FESTIVAL"
        >
            <el-table
                v-loading="isLoading"
                :data="data"
                highlight-current-row
                style="width:100%;"
                @current-change="_handleRowSelect"
            >
                <el-table-column
                    label="Название"
                >
                    <template slot-scope="scope">
                        {{ scope.row.attributes.title }}
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row v-else-if="currentMode === componentModes.IMPORT_PROCESS">
            <process-bar :percentage="percentages" />
        </el-row>
        <el-row v-else>
            {{ resultMessageText }}
            <el-row v-if="errors.length > 0">
                При переносе персонала возникли ошибки.<br>
                <el-link
                    type="danger"
                    @click="_showErrorDialog"
                >
                    Посмотреть
                </el-link>
                <el-dialog
                    title="Ошибки переноса"
                    :visible.sync="showErrorDialog"
                    append-to-body
                >
                    <div
                        v-for="(error, index) in errors"
                        :key="index"
                    >
                        {{ error }}
                    </div>
                    <div slot="footer">
                        <el-button
                            @click="_closeErrorDialog"
                        >
                            Закрыть
                        </el-button>
                    </div>
                </el-dialog>
            </el-row>
        </el-row>
        <div
            slot="footer"
            style="text-align: left"
        >
            <el-button
                v-if="currentMode === componentModes.SELECT_FESTIVAL"
                type="primary"
                :disabled="!selectedId"
                @click="_onImportClick"
            >
                Импортировать
            </el-button>
            <el-button
                v-else-if="currentMode ===componentModes.IMPORT_RESULT"
                type="success"
                @click="close"
            >
                Закрыть
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { Event } from '@/api';
import ProcessBar from '@/modules/event/components/personnelImport/ProcessBar';

export default {
    name: 'EventSelectPopup',
    components: { ProcessBar },
    props: {
        eventId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            componentModes: {
                SELECT_FESTIVAL: 1,
                IMPORT_PROCESS: 2,
                IMPORT_RESULT: 3
            },
            data: [],
            currentMode: 1,
            isLoading: false,
            loaded: false,
            showDialog: false,
            showErrorDialog: false,
            selectedId: '',
            percentages: 0,
            message: 'Персонал успешно перенесен',
            errors: [
                'Один не один не може быть два два.',
                'Один не один не може быть два два.',
                'Один не один не може быть два два.',
                'Один не один не може быть два два.',
                'Один не один не може быть два два.',
                'Один не один не може быть два два.',
                'Один не один не може быть два два.'
            ]
        };
    },
    computed: {
        confirmMessageText() {
            let info = this.data.find(item => item.id === this.selectedId);
            return `Импортировать персонал с ${info.attributes.title || ''}`;
        },
        titleMessageText() {
            let text;
            switch (this.currentMode) {
            case this.componentModes.SELECT_FESTIVAL:
                text = 'Выберите фестиваль для переноса персонала';
                break;
            case this.componentModes.IMPORT_PROCESS:
                text = 'Перенос персонала в процессе...';
                break;
            case this.componentModes.IMPORT_RESULT:
                text = 'Персонал перенесен';
                break;
            }
            return text;
        },
        resultMessageText() {
            let info = this.data.find(item => item.id === this.selectedId);
            return `В этот фестиваль перенесен персонал с фестиваля:  ${info ? info.attributes.title : ''}`;
        },
        showCloseModal() {
            return this.currentMode !== this.componentModes.IMPORT_PROCESS;
        }
    },
    methods: {
        open() {
            if (!this.loaded) {
                this._loadLastEvents();
            }
            this.showDialog = true;
        },
        close() {
            this.showDialog = false;
            this.selectedId = '';
            this._unsubscribeProcessEvent();
        },
        _handleRowSelect(row) {
            this.selectedId = row.id;
        },
        _onImportClick() {
            this.$confirm(this.confirmMessageText, 'Внимание', {
                confirmButtonText: 'Да',
                cancelButtonText: 'Отмена',
                type: 'warning'
            })
                .then(() => {
                    this.currentMode = this.componentModes.IMPORT_PROCESS;
                    this._startProcess()
                        .then(response => {
                            this.currentMode = this.componentModes.IMPORT_RESULT;
                            this.message = response.message;
                            this.errors = response.errors || this.errors;
                        });
                });
        },
        _loadLastEvents() {
            this.isLoading = true;
            Event.getAllEvents({
                params: {
                    limit: 3,
                    offset: 1,
                    eventId: this.eventId
                }
            })
                .then(eventResources => {
                    this.data = eventResources;
                    this.loaded = true;
                })
                .catch(e => {
                    this.$message.error('При загрузке данных произошла ошибка');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        _startProcess() {
            this._subscribeToProcessEvent();
            return Event.movePersonnel({ fromEvent: this.selectedId, toEvent: this.eventId })
                .then(response => {
                    this._unsubscribeProcessEvent();
                    return Promise.resolve(response);
                });
        },
        _subscribeToProcessEvent() {
            this.$echo.private(`TransferProcess.${this.eventId}`)
                .listen('PersonalTransferBatchEvent', (status) => {
                    this.percentages = status.percentage;
                });
        },
        _unsubscribeProcessEvent() {
            this.$echo.leave(`TransferProcess.${this.eventId}`);
        },
        _showErrorDialog() {
            this.showErrorDialog = true;
        },
        _closeErrorDialog() {
            this.showErrorDialog = false;
        }
    }
};
</script>

<style lang="scss">
.event-select-popup {
  &__header {
    text-align: center;
  }
}
</style>
